<template>
  <div class="av-wrap" v-if="inited">
    <div class="ico-bofang" v-show="!isPlaying" @click="play"></div>
    <video-player class="video-player-box vjs-default-skin vjs-big-play-centered"
                  ref="videoPlayer"
                  :options="playerOptions"
                  @play="onPlayerPlay"
                  @ended="onPlayerEnded"
                  @pause="onPlayerEnded"
                  @ready="playerReadied"
    >
    </video-player>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
export default {
  name: 'ipsosAv',
  components: {
    videoPlayer
  },
  props: {
    src: String,
    option: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      inited: false,
      isPlaying: false,
      playerOptions: {

      }
    }
  },
  watch: {
    src () {
      this.initAv()
    }
  },
  computed: {},
  methods: {
    initAv () {
      this.inited = false
      const { option, src } = this
      if (src) {
        let videoSrc = src
        // 拼接路径
        if (videoSrc.indexOf('http') === -1) {
          videoSrc = (`${this.$OSS_URL}` || process.env.OSS_URL) + videoSrc
        }
        this.$nextTick(_ => {
          const playerOptions = {
            muted: false,
            language: 'zh',
            height: '100%',
            width: '100%',
            controls: false,
            playbackRates: [0.7, 1.0, 1.5, 2.0],
            poster: ''
          }
          Object.assign(playerOptions, option)
          playerOptions.sources = [{
            src: videoSrc,
            type: 'video/mp4'
          }]
          this.playerOptions = playerOptions
          this.inited = true
        })
      }
    },
    playerReadied (player) {
      this.player = player
    },
    onPlayerEnded (item, player) {
      this.isPlaying = false
    },
    onPlayerPlay (item, player) {
      this.isPlaying = true
    },
    play (item) {
      this.player.play()
    }
  },
  created () {
    this.initAv()
  },
  mounted () {
    /* this.playerOptions.sources.push({
        type: 'video/mp4',
        src: 'http://xxxxx/surveytest/8f70715d-996a-44fb-a0d4-e42d68f7e865/c9317b48-4dc9-4d0d-bab8-502f4deb0516.mp4'
      }) */
  }
}
</script>

<style lang="scss" scoped>
  .av-wrap {
    position: relative;
    display: flex;
    justify-content: center;
    >>> .video-player {
      width: 100%;
    }
  }
  .ico-bofang {
    position: absolute;
    z-index: 2;
    width: 80px;
    height: 80px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: url('~@/assets/images/icon/ico-bofang.png') no-repeat;
    background-size: 100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/plugin/element/DubuAv.vue